// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"PackageAvailabilityNotifyButton_buttonWrapper__2ld_J","icon":"PackageAvailabilityNotifyButton_icon__1PcfY"};